import { WALLET_BONNET } from '../global-constants.js';

// Insert the My Wallet Bonnet Shared Bundle
export const insertWalletBonnet = async (API, walletScriptHost) => {
	return API.loadJS(`${walletScriptHost}/${WALLET_BONNET}.js`);
}
